// src/appInit.ts
import { Capacitor } from "@capacitor/core";
import { LiveUpdate } from "@capawesome/capacitor-live-update";
import { splashScreenManager } from "./utils/splashScreenManager";

const INIT_TIMEOUT_MS = 8000;
const isProduction = process.env.REACT_APP_ENV === "production";

export async function initializeApp(): Promise<void> {
  // Only run native init on Android/iOS
  if (!Capacitor.isNativePlatform()) return;

  let timeout: ReturnType<typeof setTimeout> | undefined;
  try {
    if (isProduction) {
      // Ensure we don't keep users stuck on splash
      const timeoutPromise = new Promise<never>((_, reject) => {
        timeout = setTimeout(
          () => reject(new Error("init timeout")),
          INIT_TIMEOUT_MS
        );
      });

      // Race the sync against the timeout
      const syncPromise = (async () => {
        const { nextBundleId } = await LiveUpdate.sync();
        if (nextBundleId) {
          await LiveUpdate.reload(); // app restarts into the new bundle
          return; // no code after this line runs on this process
        }
      })();

      await Promise.race([syncPromise, timeoutPromise]);
    }
  } catch (e) {
    console.warn("initializeApp: proceeding without update", e);
  } finally {
    if (timeout) clearTimeout(timeout);
    // Mark init as completed, but don't hide splash screen yet
    // It will be hidden when dashboard loading completes
    splashScreenManager.setInitCompleted();
  }
}
